module.exports = __webpack_public_path__ + "img/download-6.ff1c597b.png";